import { Document, DocumentInfo } from "@/types/document";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { formatDateLocal } from "./dates";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function populateDocumentTitle<T extends Document | DocumentInfo>(doc: T): T {
  if (doc.title) return doc;

  const fileName = (doc as DocumentInfo).fileName;
  if (fileName) {
    return { ...doc, title: fileName };
  }

  const date = (doc as DocumentInfo).createdAt || new Date();
  const formattedDate = formatDateLocal(date, { dateStyle: "medium", timeStyle: undefined });
  
  return { ...doc, title: `Oral assignment - ${formattedDate}` };
}

export function populateDocuments<T extends Document | DocumentInfo>(docs: T[] | null): T[] | null {
  if (!docs) return null;
  return docs.map(populateDocumentTitle);
}

export const resolveOrganization = () => {
    // Get orgId from URL query params (development)
    const searchParams = new URLSearchParams(window.location.search);
    const orgId = searchParams.get("orgId");
  
    if (orgId) {
      return orgId;
    }

    const host = window.location.hostname; // e.g. hkbu.clairelabs.ai
    const parts = host.split('.');
  
    if (parts.length === 3) {
      const subdomain = parts[0];
      if (!subdomain.startsWith('app')) {
        return subdomain;
      }
    }
  
    return null;

}